// biome-ignore lint/style/noVar: <explanation>
declare var window: Window;

export const isTacticAppWebView = () => {
  //@ts-ignore
  if (typeof window === "undefined") return false;

  // Check for the presence of the Tactic App WebView user agent
  //@ts-ignore
  const userAgent = window.navigator.userAgent || "";
  return userAgent.includes("TacticMobileAppWebView");
};

export const isTacticKioskWebView = () => {
  //@ts-ignore
  if (typeof window === "undefined") return false;

  //@ts-ignore
  const userAgent = window.navigator.userAgent || "";
  return userAgent.includes("TacticKioskWebView");
};

/** True inside a Station build that can open the native display settings panel. */
export const canOpenKioskDisplaySettings = () => {
  if (!isTacticKioskWebView()) return false;

  // Injected by the Station app before the kiosk loads; older builds don't set it.
  const kioskWindow = window as Window & {
    __kioskSupportsDisplaySettings__?: boolean;
  };
  return kioskWindow.__kioskSupportsDisplaySettings__ === true;
};
